import { createFileRoute } from '@tanstack/react-router'
import { LegalPage } from '@/features/auth/legal-page'
export const Route = createFileRoute('/legal')({ component: LegalPage })
